import { createSelector } from 'reselect';
import { selectFeatureFlags } from 'core/userContext';

import { SELECTABLE_ITEM_TYPE } from './constants';
import {
  ReduxStateWithWorkflowIndex,
  SelectableItem,
  WorkflowId,
  WorkflowNodeTemplateId,
} from './types';

export const selectThumbnails = (state: ReduxStateWithWorkflowIndex) =>
  state.workflowIndex.thumbnails;

export const selectThumbnail = (templateId?: WorkflowNodeTemplateId | null) =>
  createSelector([selectThumbnails], (thumbnails) =>
    templateId ? thumbnails[templateId] : undefined,
  );

export const selectAllSendActivity = (state: ReduxStateWithWorkflowIndex) =>
  state?.workflowIndex?.sendActivity;

export const selectSendActivity = (workflowId: WorkflowId) =>
  createSelector([selectAllSendActivity], (allSendActivity) => allSendActivity?.[workflowId]);

export const selectSelectedItems = (state: ReduxStateWithWorkflowIndex) =>
  state.workflowIndex.selectedItems;

export const selectSelectedItemsByType = (itemType: SELECTABLE_ITEM_TYPE) =>
  createSelector([selectSelectedItems], (selectedItems) => selectedItems[itemType] || new Set());

export const selectIsItemSelected = (item: SelectableItem) =>
  createSelector([selectSelectedItemsByType(item.type)], (selectedItems) =>
    selectedItems.has(item.id),
  );

export const selectIsStartTileRefreshEnabled = (state: any) =>
  selectFeatureFlags(state)?.StartTileRefresh === true;

export const selectIsJourneyLabelsEnabled = (state: any) =>
  selectFeatureFlags(state)?.JourneyLabels === true;
